import React, { useState, Component } from 'react';
import { Send, CheckCircle2 } from 'lucide-react';
import { getUtmParams } from '../utils/utmTracking';
interface EventsLeadFormProps {
  variant?: 'light' | 'dark';
  title?: string;
  subtitle?: string;
}
export function EventsLeadForm({
  variant = 'light',
  title = 'בואו נתכנן את האירוע שלכם',
  subtitle = 'השאירו פרטים ונחזור אליכם לבניית אירוע מותאם אישית'
}: EventsLeadFormProps) {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.fullName.trim() || !formData.phone.trim()) return;
    setIsSubmitting(true);
    // Capture UTM params
    getUtmParams();
    // Track Meta Pixel event for Lead
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'Lead', {
        content_name: 'Events and Workshops',
        currency: 'ILS'
      });
    }
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      // Redirect to WhatsApp after successful submission
      const text = encodeURIComponent(`היי, השארתי פרטים בדף אירועים וסדנאות.\nשם: ${formData.fullName}\nטלפון: ${formData.phone}`);
      window.open(`https://wa.me/972548800260?text=${text}`, '_blank');
    }, 1000);
  };
  const isDark = variant === 'dark';
  const titleColor = isDark ? 'text-white' : 'text-[#0A5F8F]';
  const subtitleColor = isDark ? 'text-blue-100' : 'text-gray-600';
  const inputClass = isDark ? 'w-full bg-white/90 border-0 rounded-xl py-3 px-4 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-cyan-400 transition-all' : 'w-full bg-white border border-gray-200 rounded-xl py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-cyan-400 focus:border-transparent transition-all';
  if (isSubmitted) {
    return <div className="text-center py-8" data-id="element-184" data-mp="x44tgsbzy99v">
        <div className={`w-16 h-16 ${isDark ? 'bg-emerald-500/20' : 'bg-emerald-100'} rounded-full flex items-center justify-center mx-auto mb-4`} data-id="element-185" data-mp="x33l4vmd80vu">
          <CheckCircle2 className={`w-8 h-8 ${isDark ? 'text-emerald-400' : 'text-emerald-600'}`} data-id="element-186" data-mp="nd1txuypu2cp" />
        </div>
        <h3 className={`text-2xl font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-187" data-mp="s5bs1y9zi8q2">
          איזה כיף!
        </h3>
        <p className={isDark ? 'text-gray-200' : 'text-gray-600'} data-id="element-188" data-mp="dgyr0mw1hzop">
          הפרטים התקבלו בהצלחה. נחזור אלייך בהקדם עם כל המידע.
        </p>
      </div>;
  }
  return <div data-id="element-189" data-mp="4efs2dvdk77q">
      <h3 className={`text-2xl font-bold mb-2 text-center ${titleColor}`} data-id="element-190" data-mp="4fqvgckwrcyb">
        {title}
      </h3>
      <p className={`text-center mb-6 text-sm ${subtitleColor}`} data-id="element-191" data-mp="9cr32rxeonrj">{subtitle}</p>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-192" data-mp="3lwv4rtxy69po">
        <input type="text" name="fullName" value={formData.fullName} onChange={handleFormChange} required placeholder="שם מלא" className={inputClass} data-id="element-193" data-mp="3lzhe9z4eezaj" />
        <input type="tel" name="phone" value={formData.phone} onChange={handleFormChange} required dir="ltr" placeholder="טלפון" className={`${inputClass} text-right`} data-id="element-194" data-mp="3uz4dqfdkhv0y" />
        <input type="email" name="email" value={formData.email} onChange={handleFormChange} dir="ltr" placeholder="אימייל (אופציונלי)" className={`${inputClass} text-right`} data-id="element-195" data-mp="8ql9nro276ko" />

        <button type="submit" disabled={isSubmitting} className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-400 hover:to-blue-400 text-white font-bold py-4 rounded-xl transition-all shadow-lg flex items-center justify-center gap-2 mt-2" data-id="element-196" data-mp="3pxlddr7t3u5">
          {isSubmitting ? <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-197" data-mp="rhw1cb1lzndm"></div> : <>
              <Send className="w-5 h-5" data-id="element-198" data-mp="mg6nknn04vlu" />
              דברו איתי!
            </>}
        </button>
      </form>
    </div>;
}